/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the auth module.
 */

export const PANELACTIVE = 'PANELACTIVE'

export default {
  PANELACTIVE,
}


// WEBPACK FOOTER //
// ./src/store/modules/sinisters/mutation-types.js